<template>
  <div class="assessment-row" @click="openAssessment">
    <div class="campaign">
      <span class="headline">{{ props.assessment.campaign.campaign.headline }}</span>
    </div>
    <!-- <div>{{ props.assessment.campaign.campaign.job_title }}</div> -->
    <div class="date">{{ formatDate(props.assessment.creation_time, locale) }}</div>
    <div class="steps hide-sm">
      <span>{{ stepsText }}</span>
      <div v-if="props.status === 'started'" class="exp-progress">
        <div class="exp-progress-value" :style="{ width: `${progress}%` }"></div>
      </div>
    </div>
    <div class="actions">
      <Button v-if="props.status === 'finished'" class="green icon icon-left m" icon="bi-download" :label="$t('app.experience.list.finished.action')" :aria-label="`${$t('app.experience.list.finished.action')} : ${props.assessment.campaign.campaign.headline}`" @click="downloadResults" />
      <Button v-else class="primary icon icon-right m" icon="bi-arrow-right" :label="$t(`app.experience.list.${props.status}.action`)" :aria-label="`${$t(`app.experience.list.${props.status}.action`)} : ${props.assessment.campaign.campaign.headline}`" @click="openAssessment" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useToast } from "vue-toastification";
import { useAssessmentTracking } from '@/queries/assessment.query';
import type { ParticipantV4 } from '@/types/participant';
import { AssessmentStatus, formatDate } from '../assessmentStatus';

const props = defineProps<{
  assessment: ParticipantV4,
  status: AssessmentStatus,
}>();

const router = useRouter();
const toast = useToast();
const { t, locale } = useI18n();

const { data: tracking } = useAssessmentTracking(computed(() => props.assessment.participant_id));

const total = computed(() => tracking.value?.total_situations.length ?? props.assessment.campaign.assessment.situations.length);
const completed = computed(() => tracking.value?.completed_situations.length ?? 0);
const progress = computed(() => total.value ? Math.round((completed.value / total.value) * 100) : 0);

const stepsText = computed(() => {
  if (props.status === 'invited') return t('app.experience.steps', total.value);
  return t('app.experience.stepsProgress', { completed: completed.value, total: total.value });
});

function openAssessment() {
  router.push({ name: 'assessment', params: { participantId: props.assessment.participant_id } });
}

function downloadResults() {
  // TODO: plug the v4 results download once the backend is available
  toast.info(t('app.experience.notAvailable'));
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";
@import "../experience.scss";

.assessment-row {
  display: grid;
  grid-template-columns: $experience-table-columns;
  column-gap: 16px;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid var(--light-grey-color);
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: var(--light-white-color);
  }

  .campaign {
    min-width: 0;

    .headline {
      font-weight: 600;
    }
  }

  .date {
    font-variant-numeric: tabular-nums;
  }

  .steps {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-variant-numeric: tabular-nums;

    .exp-progress {
      height: 4px;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    row-gap: 8px;

    .hide-sm {
      display: none;
    }

    .actions {
      justify-content: flex-start;
    }
  }
}
</style>
